export default __webpack_public_path__ + "static/media/determination.fe9e3ec8.png";